exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fs-13[data-v-df6d7668] {\n  font-size: 13px;\n}\n.card.card-collapse > .card-header[data-v-df6d7668] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.card.card-collapse > .card-header > i[data-v-df6d7668] {\n    cursor: pointer;\n    transition: transform ease-in-out 200ms;\n}\n.card.card-collapse.is-openned > .card-header > i[data-v-df6d7668] {\n  transform: rotate(180deg);\n}\n", ""]);

// exports
